// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
const env = import.meta.env as Record<string, string>;

export default {
    APP_URL: window.location.origin.toString(),
    WS_URL: env.VITE_WS_URL,
    SERVICES_URL: env.VITE_SERVICES_URL,
    WHEELS_URL: env.VITE_WHEELS_URL,
    PASS_URL: env.VITE_PASS_URL,

    TRANSITION: env.VITE_TRANSITION === 'true',
    SENTRY_DSN: env.VITE_SENTRY_DSN,
};
